<script>
import { mapActions } from 'vuex'
import Modal from '@/components/Modal'
import ModalHeader from '@/components/ModalHeader'
import Action from '@/components/Action'
import Icon from '@/components/Icon'
import { getUserErrorMessage } from '@/services/userError'

export default {
  name: 'ModalClearCart',

  components: {
    Modal,
    ModalHeader,
    Action,
    Icon,
  },

  props: {
    active: {
      type: Boolean,
      default: false,
    },

    order: {
      type: Object,
      default: () => ({}),
    },
  },

  data () {
    return {
      loading: false,
    }
  },

  methods: {
    ...mapActions('orders', ['clearOrder']),
    ...mapActions(['setFeedback']),

    closeModal () {
      this.$emit('update:active', false)
    },

    handleClearCart () {
      if (!this.order || !this.order.products || this.order.products.length === 0) {
        this.closeModal()
        return
      }

      this.loading = true
      this.clearOrder({ id: this.order.id }).then(() => {
        this.setFeedback({ title: 'Carrinho limpo com sucesso', message: '', type: 'success' })
        this.$emit('confirm')
        this.closeModal()
      }).catch((error) => {
        const message = getUserErrorMessage(error, 'Erro ao limpar carrinho')
        this.setFeedback({ title: 'Erro ao limpar carrinho', message: message, type: 'error' })
      }).finally(() => {
        this.loading = false
      })
    },
  },
}
</script>

<template>
  <modal :active="active" @close="closeModal" :width="'500px'">
    <modal-header title="Limpar o carrinho" message="Tem certeza que deseja remover todos os produtos do pedido?" />
    <div :class="$classes['order']">
      <span :class="$classes['order-label']">Pedido</span>
      <span :class="$classes['order-value']">{{ order.name }}</span>
    </div>
    <div :class="$classes['actions']">
      <action variant="flat" color="secondary" uppercase bold @click="closeModal">
        <icon v-if="!$media.mobile" name="long-arrow-alt-left" btnIcon />
        Cancelar
      </action>
      <action variant="contained" color="secondary" :loading="loading" :disabled="loading" @click="handleClearCart">
        Limpar
      </action>
    </div>
  </modal>
</template>

<style module>
.order {
  margin-bottom: 30px;
}

.order-label {
  display: block;
  font-size: 12px;
  font-weight: bold;
  color: rgba(41, 41, 41, 0.8);
  margin-bottom: 10px;
}

.order-value {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: rgba(41, 41, 41, 0.8);
}

.total {
  display: flex;
  align-items: center;
}

.total-label {
  font-size: 14px;
  text-transform: uppercase;
  color: #a1a1a1;
  margin-right: 15px;
}

.total-value {
  font-size: 14px;
  font-weight: 500;
}

.actions {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}
</style>
